import { ConfigLoader } from '@ngx-config/core';
import { ConfigHttpLoader } from '@ngx-config/http-loader';
import { HttpClient } from '@angular/common/http';

export function configFactory(http: HttpClient): ConfigLoader {
	return new ConfigHttpLoader(http, 'assets/config.json');
}

export const ConfigSettings = {
	provide: ConfigLoader,
	useFactory: (configFactory),
	deps: [HttpClient]
};



// WEBPACK FOOTER //
// ./src/app/shared/config/config.ts